import sample_1 from './sample_1.png';

export const dynamicFlameChemReflectImpressions = {
    sample_1,
};
